import React,{useState} from 'react';
import './calltoaction.scss';
import ModalContact from './ModalContact';

function CallToAction(props) {

    const [visible, setVisible] = useState(false);
    return (
       <div className="calltoaction-card">
           <button onClick={()=>setVisible(true)}>立即报名</button>
           <div className="pop-box">
            <div className="popover">
                    <div className="wechat">
                    <img src="./images/wechat.svg" />
                    </div>
                    <div className="text">
                        <div className="title">联系老师微信</div>
                        <div className="desc">扫码或添加<br />微信号：lzhmeng<br />领取报礼包</div>
                    </div>
                    <div className="qrcode">
                        <img src="./images/qrcode.jpg" />
                    </div>
            </div>
           </div>

           <ModalContact visible={visible} onClose={()=> setVisible(false)} />
       </div>
    );
}

export default CallToAction;